module.exports = __webpack_public_path__ + "static/img/flowIcon4.c8fab85.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flowIcon4.png
// module id = 923X
// module chunks = 1